/**
 * 健康状况枚举
 */
export default Object.freeze([
    '良好',
    '一般',
    '较差',
])